import { colors } from '@constants/colors';

export const useStyles = () => {
  return {
    revokeConsentText: {
      textDecoration: 'underline',
      fontWeight: 500,
      fontSize: '14px',
      marginTop: '20px',
      cursor: 'pointer',
      color: colors.grey_500,
    },
  };
};
